import React from "react";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { BaseService } from "./Service";
import { IconName } from "@my-dld/components/AppIcon";


export interface AppService extends BaseService {
	registerService( service: AppServiceItem ): void;

	getServices( options?: any ): AppServiceItem[];
}

export interface AppServiceHandler {
	( service: AppServiceItem, options?: any ): void;
}

export interface AppServiceItem {
	id: string;
	label: LocaleValue | string;
	action: AppServiceHandler;
	descriptionProvider?: { [ k: string ]: LocaleValue },
	order?: number;
	isEnabled?: ( options?: any ) => boolean;
	userRole?: number
	path?: string;
	description?: string;
	hide?: boolean;
	allowUnverifiedEmailUsers: boolean;
	icon?: string | IconName;
}


class AppServiceImpl implements AppService {
	readonly services: AppServiceItem[] = [];

	registerService( service: AppServiceItem ): void {
		this.services.push( service );
	}

	getServices( options?: any ) {
		return this.services.filter( svc => {
			if ( svc.hide ) return false;
			if ( svc.isEnabled ) {
				return svc.isEnabled( options );
			}
			return true;
		} );
	}
}

const appService = new AppServiceImpl();
export default appService;
